import { render, staticRenderFns } from "./Percorso.vue?vue&type=template&id=144d4c5d&scoped=true&"
import script from "./Percorso.vue?vue&type=script&lang=js&"
export * from "./Percorso.vue?vue&type=script&lang=js&"
import style0 from "./Percorso.vue?vue&type=style&index=0&id=144d4c5d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144d4c5d",
  null
  
)

export default component.exports